module.exports = __webpack_public_path__ + "static/media/logo-wbs-recruiting-international.267d4019.svg";